import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

export default function Privacy() {
  return (
    <>
      <main className="legal-page">
        <div className="container">
          <Link to="/" className="legal-back">← Back to Ripple</Link>
          <h1 className="legal-title">Privacy Policy</h1>
          <p className="legal-date">Last updated: May 24, 2026</p>

          <div className="legal-body">
            <p className="legal-lead">
              Ripple does not collect or store personal data directly. The app is free and
              supported by advertising, which may involve data collection by our ad partner
              as described below.
            </p>

            <div>
              <h2 className="legal-section-title">1. Data we collect</h2>
              <p className="legal-text">
                We do not collect any personally identifiable information (PII) ourselves. All
                game progress, statistics, and settings are stored locally on your device and
                are never transmitted to our servers.
              </p>
            </div>

            <div>
              <h2 className="legal-section-title">2. Advertising</h2>
              <p className="legal-text">
                Ripple is free to play and displays ads to support development. Our ad provider
                may collect device identifiers and usage data to serve relevant ads and measure
                ad performance. You can limit ad tracking through your device's privacy settings
                (iOS: Settings → Privacy &amp; Security → Apple Advertising).
              </p>
            </div>

            <div>
              <h2 className="legal-section-title">3. Analytics</h2>
              <p className="legal-text">
                We do not use third-party analytics or crash reporting services that collect
                personal data beyond what is described in the Advertising section above.
              </p>
            </div>

            <div>
              <h2 className="legal-section-title">4. Notifications</h2>
              <p className="legal-text">
                If you enable daily reminders, Ripple uses local push notifications scheduled
                entirely on your device. No data leaves your device for this purpose.
              </p>
            </div>

            <div>
              <h2 className="legal-section-title">5. Third-party services</h2>
              <p className="legal-text">
                Apart from our ad provider, Ripple does not integrate with third-party services
                or social networks. We do not sell your data to any third party.
              </p>
            </div>

            <div>
              <h2 className="legal-section-title">6. Children</h2>
              <p className="legal-text">
                Ripple does not knowingly collect personal data from users under 13. Ad serving
                in the app complies with Apple's requirements for apps available to children.
              </p>
            </div>

            <div>
              <h2 className="legal-section-title">7. Changes</h2>
              <p className="legal-text">
                If this policy changes, we will update the "Last updated" date above.
              </p>
            </div>

            <div>
              <h2 className="legal-section-title">8. Contact</h2>
              <p className="legal-text">
                Questions? Email: <a href="mailto:mimzeslami@gmail.com">mimzeslami@gmail.com</a>
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
